/**
 * Offline functionality for Florida's Scenic Byways
 * Handles service worker registration and offline status
 */

class OfflineHandler {
	constructor() {
		this.isOnline = navigator.onLine;
		this.setupEventListeners();
		this.registerServiceWorker();
	}

	/**
	 * Setup online/offline event listeners
	 */
	setupEventListeners() {
		// Listen for online/offline events
		window.addEventListener('online', () => {
			this.isOnline = true;
			this.updateOfflineStatus(false);
			console.log('Application is online');
		});

		window.addEventListener('offline', () => {
			this.isOnline = false;
			this.updateOfflineStatus(true);
			console.log('Application is offline');
		});
	}

	/**
	 * Register the service worker
	 */
	registerServiceWorker() {
		if ('serviceWorker' in navigator) {
			window.addEventListener('load', () => {
				navigator.serviceWorker.register('/sw.js')
					.then(registration => {
						console.log('ServiceWorker registered with scope:', registration.scope);
					})
					.catch(error => {
						console.error('ServiceWorker registration failed:', error);
					});
			});
		} else {
			console.warn('Service workers are not supported in this browser.');
		}
	}

	/**
	 * Update UI to indicate offline status
	 * @param {boolean} isOffline - Whether the app is offline
	 */
	updateOfflineStatus(isOffline) {
		if (isOffline) {
			this.showOfflineBanner();
		} else {
			this.hideOfflineBanner();
		}
	}

	/**
	 * Show offline notification banner
	 */
	showOfflineBanner() {
		// If banner already exists, don't create another one
		if (document.getElementById('offline-banner')) return;

		const banner = document.createElement('div');
		banner.id = 'offline-banner';
		banner.className = 'offline-banner';

		banner.innerHTML = `
      <div class="offline-content">
        <i class="fas fa-wifi-slash"></i>
        <span>You are currently offline. Some features may be limited.</span>
        <button id="close-offline-banner">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `;

		document.body.appendChild(banner);

		// Add event listener to close button
		document.getElementById('close-offline-banner').addEventListener('click', () => {
			this.hideOfflineBanner();
		});

		// Show banner with animation
		setTimeout(() => {
			banner.classList.add('visible');
		}, 100);
	}

	/**
	 * Hide offline notification banner
	 */
	hideOfflineBanner() {
		const banner = document.getElementById('offline-banner');
		if (banner) {
			banner.classList.remove('visible');
			setTimeout(() => {
				if (banner.parentNode) {
					banner.parentNode.removeChild(banner);
				}
			}, 300); // Match transition duration
		}
	}

	/**
	 * Check if the application is online
	 * @returns {boolean} isOnline status
	 */
	getOnlineStatus() {
		return this.isOnline;
	}
}

// Initialize the offline handler
const offlineHandler = new OfflineHandler();

// If we're already offline when loading, show the banner
if (!navigator.onLine) {
	offlineHandler.updateOfflineStatus(true);
}

// Export the handler
export default offlineHandler;
